import SinglePost from './SinglePost'
import GalleryPlayer from './GalleryPlayer';
import { useState } from 'react';

const GalleryLayout = ({ feedSettings, posts, headerData, isPro, editorActiveDevice, isFeedEditor, feedId }) => {
    const [activePost, setActivePost] = useState(posts[0] || null);
    const [activeIndex, setActiveIndex] = useState(posts.length > 0 ? 0 : null);
    const [isPlaying, setIsPlaying] = useState(false);

    let desktopNumber = feedSettings.galleryDesktopColumns;

    if (isFeedEditor) {
        switch (editorActiveDevice.device) {
            case 'mobile':
                desktopNumber = feedSettings.galleryMobileColumns;
                break;
            case 'tablet':
                desktopNumber = feedSettings.galleryTabletColumns;
                break;
            default:
                desktopNumber = feedSettings.galleryDesktopColumns;
                break;
        }
    }

    //
    const handleGalleryPlayer = (postIndex, triggerEl) => { // accept the trigger el SinglePost passes (was dropped) for focus mgmt
        setActivePost(posts[postIndex]);
        setIsPlaying(true);
        setActiveIndex(postIndex);

        // scroll to GalleryPlayer. 
        const feedContainer = document.getElementById(`sb-tiktok-feeds-container-${feedId}`);
        if (feedContainer) {
            feedContainer.scrollIntoView({ behavior: 'smooth' });
        }

    }

    const columnGap = `${ feedSettings.horizontalSpacing === "" || feedSettings.horizontalSpacing == null ? 16 : feedSettings.horizontalSpacing }px`;
    const rowGap = `${ feedSettings.verticalSpacing === "" || feedSettings.verticalSpacing == null ? 16 : feedSettings.verticalSpacing }px`;

    return (
        <>
            {
                activePost &&
                <GalleryPlayer
                    post={activePost}
                    headerData={headerData}
                    isPlaying={isPlaying}
                    setIsPlaying={setIsPlaying}
                />
            }

            {/* a11y(SMASH-1377 F7): gallery uses the same direct-child grid
              * wrapper as the grid layout but omitted its list semantics —
              * mirror GridLayout's role=list + isListItem so SR rotor users
              * get the same 'list of N items' structure (WCAG 1.3.1). The
              * SinglePost wraps are direct children, so the roles are valid. */}
            <div
                className='sb-grid-wrapper sb-fs'
                role="list"
                data-grid-columns={desktopNumber}
                data-grid-tablet-columns={feedSettings.galleryTabletColumns}
                data-grid-mobile-columns={feedSettings.galleryMobileColumns}
                style={{
                    display: 'grid',
                    columnGap,
                    rowGap
                }}
            >
                {
                    posts.map((post, postIndex) =>
                        <SinglePost
                            headerData={headerData}
                            post={post}
                            postIndex={postIndex}
                            feedSettings={feedSettings}
                            key={postIndex}
                            isPro={isPro}
                            isFeedEditor={isFeedEditor}
                            handlePostClick={handleGalleryPlayer}
                            isPlaying={isPlaying}
                            setIsPlaying={setIsPlaying}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                            isListItem={true}
                        />
                    )
                }
            </div>
        </>
    )
}

export default GalleryLayout;